export const colorArrayToLinearGradient = (colorArray, deg = 45) => {
    const step = Math.round(100/colorArray.length)
    const colorSet = colorArray.map((color, idx) => `${color} ${idx * step}%`).join(', ')
    return `linear-gradient(${deg}deg, ${colorSet}`
}

export const ColorSchemes = {
    Kyra: ['#3f1e91', '#6019ae', '#840af8'],
    Sunrise: ["#FF512F", "#F09819", "#FF416C"],
    Ocean: ["#2193b0", "#6dd5ed", "#00d2ff", "#928DAB"],
    Forest: ["#11998e", "#56ab2f", "#a8e063"],
    Desert: ["#F7971E", "#FFD200", "#FDC830"],
    Aurora: ["#7F00FF", "#E100FF", "#00C9A7"]
}